import { apiClient } from '../apiClient'
import type { NoteWithUser, CreateLandNoteDto } from '@popety-io/types'

export const notesService = {
  // Get notes for a specific land
  getLandNotes: async (landId: number | string): Promise<NoteWithUser[]> => {
    const response = await apiClient.get(`/notes/land/by-land/${landId}`)
    // The API returns an array of notes directly
    return response.data || []
  },

  // Create a new note for a land
  createLandNote: async (
    landId: string,
    data: CreateLandNoteDto
  ): Promise<NoteWithUser> => {
    const response = await apiClient.post(`/notes/land/by-land/${landId}`, data)
    return response.data
  },

  // Update an existing note
  updateLandNote: async (
    noteId: number,
    data: CreateLandNoteDto
  ): Promise<NoteWithUser> => {
    const response = await apiClient.put(`/notes/land/${noteId}`, data)
    return response.data
  },

  // Delete a note
  deleteLandNote: async (noteId: number): Promise<void> => {
    await apiClient.delete(`/notes/land/${noteId}`)
  },
}
